import type * as React from "react";

import type { FieldAppearance } from "./input";
import { bareFieldClass, fieldClass } from "../../lib/surfaces";

/** The design system's recessed text field (`@crow/ui`) on several lines, growing with its text. */
function Textarea({
	className,
	appearance = "control",
	...props
}: React.ComponentProps<"textarea"> & { appearance?: FieldAppearance }) {
	const geometry = "flex field-sizing-content min-h-16 rounded-control px-2.5 py-1.5 leading-5";
	return (
		<textarea
			data-slot="textarea"
			data-appearance={appearance}
			className={
				appearance === "control"
					? fieldClass(geometry, className)
					: bareFieldClass(
							geometry,
							appearance === "document" &&
								"px-0 focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-ring/30",
							className,
						)
			}
			{...props}
		/>
	);
}

export { Textarea };
